import React from "react";
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
// import EditIcon from '@material-ui/icons/Edit';
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import NavigationIcon from '@material-ui/icons/Navigation';

const Bar = () => (
  <>
    <div id="loading">
      <div className={"load-circle"}>
        <span className={"one"} />
      </div>
    </div>
    <header className={"header-nav header-white"}>
      <div className={"fixed-header-bar"}>
        <div className={"navbar navbar-main navbar-expand-lg"}>
          <div className={"container"}>
            <a className={"navbar-brand"} href={"/"}>
              <img
                className={"logo-dark resize-img"}
                alt="logo"
                src={process.env.PUBLIC_URL + "/img/logofs.png"}
                loading={"lazy"}
                width={"250px"}
                height={"40px"}
              />
              <img
                className={"logo-light resize-img"}
                alt="light-logo"
                src={process.env.PUBLIC_URL + "/img/logofs-wh.png"}
                loading={"lazy"}
                width={"250px"}
                height={"40px"}
              />
            </a>
            <button
              className={"navbar-toggler"}
              type={"button"}
              data-toggle={"collapse"}
              data-target={"#navbar-main-collapse"}
              aria-controls={"navbar-main-collapse"}
              aria-expanded={"false"}
              aria-label={"Toggle navigation"}
            >
              <span className={"navbar-toggler-icon"} />
            </button>
            <div
              className={"collapse navbar-collapse navbar-collapse-overlay"}
              id={"navbar-main-collapse"}
            >
              <ul className={"navbar-nav ml-auto"}>
                <li className={"nav-item"}>
                  <a className={"nav-link"} href="#services">
                    Services
                  </a>
                </li>
                <li className={"nav-item"}>
                  <a className={"nav-link"} href="#plan">
                    Plan
                  </a>
                </li>
                <li className={"nav-item"}>
                  <a className={"nav-link"} href="#team">
                    Team
                  </a>
                </li>

                <li className={"nav-item"}>
                  <div className={"p-20px-t"}>
                    <a
                      className={"m-btn m-btn-radius m-btn-green m-btn-sm"}
                      href={"/FormPrice"}
                    >
                      <span className={"m-btn-inner-text"}>Quote</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            {/* <a className="d-none d-lg-inline-block m-btn m-btn-radius m-btn-theme2nd m-btn-sm m-20px-l"
              href="#">Cotiza</a> */}
          </div>
        </div>
      </div>
    </header>
  </>
);

export default Bar;
